import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import styles from './Header/Header.module.scss';

const HeaderItem = ({ children = null }) => {
  const isHeaderRedesignVariant =
    useSoyuzExperiment('HeaderRedesign').get('behaviour') === 'variant';

  const classes = classNames(styles.navItem, {
    [styles['navItem--redesign']]: isHeaderRedesignVariant
  });

  return <li className={classes}>{children}</li>;
};

export default HeaderItem;

HeaderItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ])
};
